export default "__VITE_ASSET__DNlYF$gG__"